module.exports = __webpack_public_path__ + "static/img/avatar1.7838ba2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar1.png
// module id = GTyY
// module chunks = 2